import * as React from 'react';

const SvgFormAddCircle = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2Zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2Z" })
);

export { SvgFormAddCircle as default };
//# sourceMappingURL=FormAddCircle.es.js.map
